import {
  ATTSCHEDULEDETAIL_LOADING,
  GET_ATTSCHEDULEDETAIL,
  GET_ATTSCHEDULEDETAIL_SUCCESS,
  GET_ATTSCHEDULEDETAIL_FAIL,
  ADD_ATTSCHEDULEDETAIL_SUCCESS,
  ADD_ATTSCHEDULEDETAIL_FAIL,
  DELETE_ATTSCHEDULEDETAIL_SUCCESS,
  DELETE_ATTSCHEDULEDETAIL_FAIL,
  UPDATE_ATTSCHEDULEDETAIL_SUCCESS,
  UPDATE_ATTSCHEDULEDETAIL_FAIL,
  ATTSCHEDULEDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  attScheduleDetails: [],
  error: {},
};

const AttScheduleDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ATTSCHEDULEDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ATTSCHEDULEDETAIL:
          return {
            ...state,
            attScheduleDetails: action.payload.data,
            isAttScheduleDetailCreated: false,
            isAttScheduleDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ATTSCHEDULEDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_ATTSCHEDULEDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAttScheduleDetailCreated: false,
            isAttScheduleDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ATTSCHEDULEDETAIL: {
      return {
        ...state,
        isAttScheduleDetailCreated: false,
        loading: true,
      };
    }

    case ATTSCHEDULEDETAIL_LOADING: {
      return {
        ...state,
        isAttScheduleDetailCreated: false,
        loading: true,
      };
    }

    case ADD_ATTSCHEDULEDETAIL_SUCCESS:
      return {
        ...state,
        isAttScheduleDetailCreated: true,
        loading: false,
        attScheduleDetails: [...state.attScheduleDetails, action.payload.data],
      };

    case ADD_ATTSCHEDULEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ATTSCHEDULEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isAttScheduleDetailCreated: true,
        attScheduleDetails: state.attScheduleDetails.filter(
          attScheduleDetail => attScheduleDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ATTSCHEDULEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ATTSCHEDULEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isAttScheduleDetailCreated: true,
        attScheduleDetails: state.attScheduleDetails.map(attScheduleDetail =>
          attScheduleDetail.id.toString() === action.payload.data.id.toString() ? { ...attScheduleDetail, ...action.payload.data } : attScheduleDetail
        ),
      };

    case UPDATE_ATTSCHEDULEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ATTSCHEDULEDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AttScheduleDetail;